import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TripType } from '../../../../models';
import { SearchProp } from '../../../../models/Search';

export const SegmentManager = ({ currentSearch, render }) => {
    const isRoundTrip = currentSearch.tripType === TripType.ROUND_TRIP;
    return render(isRoundTrip);
};

SegmentManager.propTypes = {
    currentSearch: SearchProp.isRequired,
    render: PropTypes.func.isRequired,
};

const mapStateToProps = ({ currentSearch }) => ({
    currentSearch,
});

export const ConnectedSegmentManager = connect(mapStateToProps)(SegmentManager);
